import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import { isEmpty } from 'lodash';
import React, { useState } from 'react';
import styled from 'styled-components/native';
import { SccButton } from '@/components/atoms';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
import BottomSheet from '@/modals/BottomSheet';
const ChallengeDetailPasscodeBottomSheet = ({ isVisible, onPressCloseButton, onPressConfirmButton, }) => {
    const [passcode, setPasscode] = useState('');
    return (_jsxs(BottomSheet, { isVisible: isVisible, children: [_jsx(Title, { children: "\uCC38\uC5EC \uCF54\uB4DC\uB97C \uC785\uB825\uD574 \uC8FC\uC138\uC694" }), _jsx(PasscodeInput, { placeholder: "\uCC38\uC5EC \uCF54\uB4DC", value: passcode, onChangeText: text => {
                    setPasscode(text);
                } }), _jsxs(ButtonContainer, { children: [_jsx(CloseButton, { text: '닫기', textColor: "black", buttonColor: "gray10", fontFamily: font.pretendardMedium, onPress: () => {
                            onPressCloseButton();
                            setPasscode('');
                        }, elementName: "challenge_passcode_close" }), _jsx(ConfirmButton, { isDisabled: isEmpty(passcode), text: '코드 입력', textColor: "white", buttonColor: "brandColor", fontFamily: font.pretendardBold, onPress: () => {
                            onPressConfirmButton(passcode);
                            setPasscode('');
                        }, elementName: "challenge_passcode_confirm" })] })] }));
};
export default ChallengeDetailPasscodeBottomSheet;
export const Title = styled.Text({
    color: color.black,
    fontSize: 20,
    fontFamily: font.pretendardBold,
    marginTop: 28,
    marginHorizontal: 24,
});
export const PasscodeInput = styled.TextInput({
    height: 56,
    borderRadius: 20,
    borderWidth: 1,
    borderColor: color.brand20,
    color: color.black,
    marginTop: 30,
    marginHorizontal: 24,
    paddingHorizontal: 25,
});
export const ButtonContainer = styled.View({
    flexDirection: 'row',
    gap: 10,
    paddingVertical: 20,
    paddingHorizontal: 20,
});
export const CloseButton = styled(SccButton) `
  flex: 1;
`;
export const ConfirmButton = styled(SccButton) `
  flex: 1;
`;
